var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"tt-loading",attrs:{"src":require("@/assets/icons-file/gif/tt_loading.gif")}})}
var staticRenderFns = []

export { render, staticRenderFns }